// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../styles/global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-template-left {
  margin: 0;
  padding: 0;
  position: fixed;
  overflow: auto;
  height: 100%;
  width: 22.9375rem;
  background-color: var(--background-color);
  padding: 2.56rem 2.81rem;
}

.page-brand-header {
  margin-bottom: 5.81rem;
}

.page-template-left .custom-button {
  width: 100%;
}

.mobile-nav-bar {
  display: none;
}

.mobile-nav-backdrop {
  display: none;
}

@media (max-width: 1024px) {
  .mobile-nav-bar {
    display: flex;
    align-items: center;
    gap: 0.94rem;
    height: 4.75rem;
    box-sizing: border-box;
    padding: 1rem 1.25rem;
    background-color: var(--background-color);
    border-bottom: 1px solid var(--background-color-darker);
    position: sticky;
    top: 0;
    z-index: 55;
  }

  .mobile-nav-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.75rem;
    height: 2.75rem;
    flex-shrink: 0;
    border: none;
    border-radius: 0.75rem;
    background-color: var(--background-color-dark);
    cursor: pointer;
  }

  .mobile-nav-brand {
    transform: scale(0.85);
    transform-origin: left center;
  }

  .page-template-left {
    width: 85vw;
    max-width: 22.9375rem;
    padding: 2.5rem 1.75rem;
    transform: translateX(-100%);
    transition: transform 0.25s ease-in-out;
    z-index: 70;
    box-shadow: 0.5rem 0 1.5rem rgba(0, 0, 0, 0.15);
  }

  .page-template-left.mobile-nav-open {
    transform: translateX(0);
  }

  .page-brand-header {
    margin-bottom: 2.5rem;
  }

  .mobile-nav-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 65;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/organisms/navBar/navBar.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,qBAAqB;IACrB,yCAAyC;IACzC,uDAAuD;IACvD,gBAAgB;IAChB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,8CAA8C;IAC9C,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,uBAAuB;IACvB,4BAA4B;IAC5B,uCAAuC;IACvC,WAAW;IACX,+CAA+C;EACjD;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,oCAAoC;IACpC,WAAW;EACb;AACF","sourcesContent":["@import \"../../styles/global.css\";\n\n.page-template-left {\n  margin: 0;\n  padding: 0;\n  position: fixed;\n  overflow: auto;\n  height: 100%;\n  width: 22.9375rem;\n  background-color: var(--background-color);\n  padding: 2.56rem 2.81rem;\n}\n\n.page-brand-header {\n  margin-bottom: 5.81rem;\n}\n\n.page-template-left .custom-button {\n  width: 100%;\n}\n\n.mobile-nav-bar {\n  display: none;\n}\n\n.mobile-nav-backdrop {\n  display: none;\n}\n\n@media (max-width: 1024px) {\n  .mobile-nav-bar {\n    display: flex;\n    align-items: center;\n    gap: 0.94rem;\n    height: 4.75rem;\n    box-sizing: border-box;\n    padding: 1rem 1.25rem;\n    background-color: var(--background-color);\n    border-bottom: 1px solid var(--background-color-darker);\n    position: sticky;\n    top: 0;\n    z-index: 55;\n  }\n\n  .mobile-nav-toggle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 2.75rem;\n    height: 2.75rem;\n    flex-shrink: 0;\n    border: none;\n    border-radius: 0.75rem;\n    background-color: var(--background-color-dark);\n    cursor: pointer;\n  }\n\n  .mobile-nav-brand {\n    transform: scale(0.85);\n    transform-origin: left center;\n  }\n\n  .page-template-left {\n    width: 85vw;\n    max-width: 22.9375rem;\n    padding: 2.5rem 1.75rem;\n    transform: translateX(-100%);\n    transition: transform 0.25s ease-in-out;\n    z-index: 70;\n    box-shadow: 0.5rem 0 1.5rem rgba(0, 0, 0, 0.15);\n  }\n\n  .page-template-left.mobile-nav-open {\n    transform: translateX(0);\n  }\n\n  .page-brand-header {\n    margin-bottom: 2.5rem;\n  }\n\n  .mobile-nav-backdrop {\n    display: block;\n    position: fixed;\n    inset: 0;\n    background-color: rgba(0, 0, 0, 0.4);\n    z-index: 65;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
